<template>
  <div>
    <q-page padding>
      <div class="row q-gutter-sm">
        <div class="col-xs-12 col-sm-8">
          <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
            Cadastrar/Editar Produto
          </p>
        </div>
      </div>
      <div
        class="row col-12 text-brand-5 q-gutter-y-sm text-weight-bold q-mt-md q-mb-lg q-ml-sm"
      >
        <div class="col-md-2 col-sm-3">
          <div>Unidade</div>
          <ListaUnidadesSelect />
        </div>
      </div>
      <div
        class="row col-12 text-brand-5 q-gutter-y-sm text-weight-bold q-my-xl q-ml-sm container-inputs"
      >
        <q-btn
          label="Cadastrar Produto"
          @click="rightDrawerOpen = true"
          :outline="!rightDrawerOpen"
          no-caps
          color="primary"
          icon="add"
        />
      </div>
      <Transition name="slide-fade">
        <q-card v-if="rightDrawerOpen" class="drawer-modal">
          <div class="row q-pa-md text-weight-bold">
            <div class="row col-12 items-center">
              <q-icon
                style="cursor: pointer"
                name="close"
                class="q-mr-md"
                size="22px"
                @click="rightDrawerOpen = false"
              />
              <span style="font-size: 16px">
                <span>
                  <span> Cadastrar Produto </span>
                </span>
              </span>
            </div>
          </div>
          <q-scroll-area class="teste" style="width: 100%; height: 92%">
            <div
              class="column col-12 justify-between no-wrap"
              style="height: 90%"
            >
              <div class="q-px-md text-weight-bold">
                <div class="col-md-12 q-mt-xs">
                  <div class="texto-titulo-input q-mb-xs">Código</div>
                  <q-input v-model="dados.code" dense outlined />
                </div>
                <div class="col-md-12 q-mt-xs">
                  <div class="texto-titulo-input q-mb-xs">Descrição</div>
                  <q-input v-model="dados.name" dense outlined />
                </div>
                <div class="col-md-12 q-mt-xs">
                  <div class="q-mb-xs">Código Integração</div>
                  <q-input v-model="dados.codigo_integracao" dense outlined />
                </div>
                <div class="col-md-12 q-mt-xs">
                  <div class="q-mb-xs">Código Integração CA</div>
                  <q-input
                    v-model="dados.codigo_integracao_ca"
                    dense
                    outlined
                  />
                </div>
                <div class="col-md-12 q-mt-xs">
                  <div class="texto-titulo-input q-mb-xs">CA</div>
                  <q-select
                    v-model="dados.ca_id"
                    @filter="filtrarCa"
                    :options="options.optionsCa"
                    option-label="label"
                    option-value="value"
                    use-input
                    dense
                    outlined
                  />
                </div>
                <div class="col-md-12 q-mt-xs">
                  <div class="texto-titulo-input">Unidade de Medida</div>
                  <q-input v-model="dados.measurement_unit" dense outlined />
                </div>
                <div class="col-md-12 q-mt-xs">
                  <div class="texto-titulo-input">
                    Descrição Unidade de Medida
                  </div>
                  <q-input
                    v-model="dados.measurement_unit_description"
                    dense
                    outlined
                  />
                </div>
                <div class="col-md-12 q-mt-xs">
                  <div class="texto-titulo-input">Categoria</div>
                  <q-select
                    v-model="dados.product_category_id"
                    :options="options.optionsCategoria"
                    @filter="filtrarCategoria"
                    use-input
                    option-label="code"
                    option-value="id"
                    dense
                    outlined
                  />
                </div>
                <div class="col-md-12 q-mt-xs">
                  <div class="texto-titulo-input">Grupo</div>
                  <q-select
                    v-model="dados.product_group_id"
                    @filter="filtrarGrupo"
                    :options="options.optionsGrupo"
                    use-input
                    option-label="name"
                    option-value="id"
                    dense
                    outlined
                  />
                </div>
                <div class="col-md-12 q-mt-xs">
                  <div class="texto-titulo-input">Preço</div>
                  <q-input
                    mask="#,##"
                    reverse-fill-mask
                    v-model="dados.price"
                    dense
                    outlined
                  />
                </div>
                <div class="col-md-12 q-mt-xs">
                  <div class="texto-titulo-input">EPI</div>
                  <q-select
                    v-model="dados.is_epi"
                    :options="options.optionsIsEpi"
                    dense
                    outlined
                  />
                </div>
              </div>
              <div class="q-px-md q-mt-md q-pb-md">
                <q-btn
                  class="q-mt-sm"
                  dense
                  icon="check_circle_outlined"
                  label="Cadastrar"
                  no-caps
                  color="positive"
                  @click="cadastrarProduto()"
                />
              </div>
            </div>
          </q-scroll-area>
        </q-card>
      </Transition>
      <div class="q-mt-xl">
        <div
          class="row col-12 justify-between text-h6 text-brand-5 text-weight-bold q-my-lg"
        >
          <span>Lista de Produtos</span>
          <div class="input-search-table col-md-3 col-xs-12">
            <q-input
              rounded
              outlined
              dense
              debounce="300"
              v-model="filtrar"
              type="text"
              class="col-xs-12 col-sm-12"
              placeholder="Pesquisar Produto"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
        </div>
        <q-table
          flat
          selection="single"
          :columns="columns"
          :loading="loading"
          dense
          color="primary"
          :rows="listaProdutos.data"
          v-model:selected="selected"
          row-key="id"
          class="tabela-tamanho-fixo"
          hide-bottom
          :rows-per-page-options="[0]"
        >
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td>
                <q-btn
                  class="q-ml-md"
                  :text-color="props.selected ? 'black' : ''"
                  no-caps
                  round
                  dense
                  :icon="props.selected ? 'close' : 'add'"
                  :color="props.selected ? 'accent' : 'primary'"
                  @click="props.selected = !props.selected"
                />
              </q-td>
              <q-td>
                <span>{{ props.row?.code }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row?.pivot?.contract_product_description || props.row?.name }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row?.pivot?.product_group?.name }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row?.pivot?.product_category?.code }}</span>
              </q-td>
              <q-td>
                <span v-if="props.row?.pivot?.price"
                  >R$ {{ parseFloat(props.row?.pivot?.price).toFixed(2) }}</span
                >
              </q-td>
              <q-td>
                <span>{{ props.row.ca?.code }}</span>
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <div class="row justify-start q-mt-md">
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            size="sm"
          />
        </div>
      </div>
      <div class="container-edicao" v-if="selected.length > 0">
        <div class="text-h6 text-brand-5 q-ml-sm text-weight-bold q-mb-md">
          Editar Produto: {{ selected[0]?.pivot?.contract_product_description || selected[0]?.name }}
        </div>
        <div class="row col-12 q-gutter-y-sm text-brand-5 text-weight-bold">
          <div class="row col-12">
            <div class="col-md">
              <div class="q-ml-sm">Código</div>
              <q-input v-model="dadosEditar.code" dense outlined />
            </div>
            <div class="col-md q-ml-sm">
              <div class="q-ml-sm">Descrição</div>
              <q-input v-model="dadosEditar.name" dense outlined />
            </div>
            <div class="col-md q-ml-sm">
              <div class="q-ml-sm">Código Integração</div>
              <q-input v-model="dadosEditar.codigo_integracao" dense outlined />
            </div>
            <div class="col-md q-ml-sm">
              <div class="q-ml-sm">Código Integração CA</div>
              <q-input
                v-model="dadosEditar.codigo_integracao_ca"
                dense
                outlined
              />
            </div>
          </div>
          <div class="row col-12">
            <div class="col-md">
              <div class="q-ml-sm">CA</div>
              <q-select
                v-model="dadosEditar.ca"
                @filter="filtrarCa"
                :options="listaCas"
                :option-label="
                  (opt) =>
                    Object(opt) === opt && 'code' in opt
                      ? `${opt.code}-${opt.status}`
                      : ''
                "
                option-value="id"
                use-input
                map-options
                dense
                outlined
              />
            </div>
            <div class="col-md q-ml-sm">
              <div class="q-ml-sm">Unidade de Medida</div>
              <q-input v-model="dadosEditar.measurement_unit" dense outlined />
            </div>
            <div class="col-md q-ml-sm">
              <div class="q-ml-sm">Descrição Unidade de Medida</div>
              <q-input
                v-model="dadosEditar.measurement_unit_description"
                dense
                outlined
              />
            </div>
            <div class="col-md q-ml-sm">
              <div class="q-ml-sm">Categoria</div>
              <q-select
                v-model="dadosEditar.product_category"
                :options="options.optionsCategoria"
                @filter="filtrarCategoria"
                use-input
                map-options
                option-label="code"
                option-value="id"
                dense
                outlined
              />
            </div>
          </div>
          <div class="row col-12">
            <div class="col-md">
              <div class="q-ml-sm">Grupo</div>
              <q-select
                v-model="dadosEditar.product_group"
                @filter="filtrarGrupo"
                :options="options.optionsGrupo"
                use-input
                map-options
                option-label="name"
                option-value="id"
                dense
                outlined
              />
            </div>
            <div class="col-md q-ml-sm">
              <div class="q-ml-sm">Preço</div>
              <q-input v-model="dadosEditar.price" dense outlined />
            </div>
            <div class="col-md q-ml-sm">
              <div class="q-ml-sm">EPI</div>
              <q-select
                v-model="dadosEditar.is_epi"
                :options="options.optionsIsEpi"
                dense
                map-options
                option-label="label"
                option-value="value"
                outlined
              />
            </div>
            <div class="col-md q-ml-sm">
              <p></p>
              <q-btn
                class="q-mt-sm q-ml-sm"
                dense
                icon="done"
                label="Editar Produto"
                no-caps
                color="positive"
                @click="editarProduto()"
              />
            </div>
          </div>
        </div>
      </div>
    </q-page>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </div>
</template>

<script setup>
import { useQuasar } from "quasar";
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

const store = useStore();
const quasar = useQuasar();

const dados = ref({
  code: "",
  name: "",
  codigo_integracao: "",
  codigo_integracao_ca: "",
  ca_id: "",
  measurement_unit: "",
  measurement_unit_description: "",
  product_category_id: "",
  product_group_id: "",
  price: "",
  is_epi: { label: "", value: "" },
});
const dadosEditar = ref({
  code: "",
  name: "",
  codigo_integracao: "",
  codigo_integracao_ca: "",
  ca: {
    code: "",
    created_at: "",
    deleted_at: "nul",
    expires_in: "",
    id: "",
    reportavel: "",
    status: "",
    updated_at: "",
  },
  measurement_unit: "",
  measurement_unit_description: "",
  product_category: {
    code: "",
    created_at: "",
    description: "",
    id: "",
    updated_at: "",
  },
  product_group: {
    created_at: "",
    description: "",
    id: "",
    name: "",
    updated_at: "3",
    vendor_id: "",
  },
  price: "",
  is_epi: { label: "", value: "" },
});
const options = ref({
  optionsCategoria: [],
  optionsCa: [],
  optionsGrupo: [],
  optionsIsEpi: [
    { label: "Sim", value: 1 },
    { label: "Não", value: 0 },
  ],
});
const listaProdutos = ref([]);
const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 10,
  rowsNumber: 6,
});
const columns = ref([
  {
    name: "selecione",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "categoria",
    label: "Categoria",
    align: "left",
  },
  {
    name: "preco",
    label: "Preço",
    align: "left",
  },
  {
    name: "ca",
    label: "CA",
    align: "left",
  },
]);
const selected = ref([]);
const listaCas = ref([]);
let rightDrawerOpen = ref(false);
const pagesNumber = computed(() =>
  Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
);
let loading = ref(false);
let disable = ref(false);
const filtrar = ref("");

const cadastrarProduto = async () => {
  if (dados.value.code == "") {
    quasar.notify({
      message: "O campo código é obrigatório",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  if (dados.value.measurement_unit == "") {
    quasar.notify({
      message: "O campo unidade de medida é obrigatório",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  if (dados.value.name == "") {
    quasar.notify({
      message: "O campo descrição é obrigatório",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  try {
    await store.dispatch("integracao/cadastrarProduto", {
      id: null,
      code: dados.value.code || null,
      name: dados.value.name || null,
      codigo_integracao: dados.value.codigo_integracao || null,
      codigo_integracao_ca: dados.value.codigo_integracao_ca || null,
      ca_id: dados.value.ca_id?.value || null,
      description: dados.value.name,
      measurement_unit: dados.value.measurement_unit || null,
      measurement_unit_description:
        dados.value.measurement_unit_description || null,
      product_category_id: dados.value.product_category_id?.id || null,
      product_group_id: dados.value.product_group_id?.id || null,
      price: parseFloat(dados.value.price.split(",").join(".")) || 0,
      is_epi: dados.value.is_epi.value,
      contrato_ca_id: dados.value.ca_id?.value || null,
    });
    resetCampos();
    rightDrawerOpen.value = false;
    quasar.notify({
      message: "Produto cadastrado com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    if (Object.keys(error.response?.data?.errors).includes("ca_id")) {
      quasar.notify({
        message: "O CA selecionado não é válido.",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    }
  }
};

const editarProduto = async () => {
  if (dadosEditar.value.code == "") {
    quasar.notify({
      message: "O campo código é obrigatório",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  if (
    dadosEditar.value.measurement_unit == "" ||
    dadosEditar.value.measurement_unit == null
  ) {
    quasar.notify({
      message: "O campo unidade de medida é obrigatório",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  if (dadosEditar.value.name == "") {
    quasar.notify({
      message: "O campo descrição é obrigatório",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    return;
  }
  try {
    await store.dispatch("integracao/cadastrarProduto", {
      id: selected.value[0].id,
      code: dadosEditar.value.code || null,
      name: dadosEditar.value.name || null,
      codigo_integracao: dadosEditar.value.codigo_integracao || null,
      codigo_integracao_ca: dadosEditar.value.codigo_integracao_ca || null,
      ca_id: dadosEditar.value.ca?.id || null,
      description: dadosEditar.value.name,
      measurement_unit: dadosEditar.value.measurement_unit || null,
      measurement_unit_description:
        dadosEditar.value.measurement_unit_description || null,
      product_category_id: dadosEditar.value?.product_category?.id || null,
      product_group_id: dadosEditar.value.product_group?.id || null,
      price: parseFloat(dadosEditar.value.price.split(",").join(".")) || 0,
      is_epi: dadosEditar.value?.is_epi.value,
      contrato_ca_id: dadosEditar.value.ca?.id || null,
    });
    selected.value = [];
    quasar.notify({
      message: "Produto editado com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    listarProdutos();
    resetCamposEditar();
  } catch (error) {
    if (Object.keys(error.response?.data?.errors).includes("ca_id")) {
      quasar.notify({
        message: "O CA selecionado não é válido.",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    }
  }
};

const listarCategorias = async (val) => {
  try {
    listaCas.value = [];
    options.value.optionsCategoria = [];
    const response = await store.dispatch("integracao/listarCategorias", {
      per_page: 1000,
    });
    options.value.optionsCategoria = response.data.results.data.filter(
      (categoria) => categoria.code.toLowerCase().includes(val)
    );
  } catch (error) {
    console.log(error);
  }
};

const listarCas = async (val) => {
  try {
    options.value.optionsCa = [];
    const response = await store.dispatch("integracao/listarCas", {
      per_page: 40,
      code: val,
    });
    listaCas.value = response.data.results.data;
    response.data.results.data.forEach((ca) => {
      options.value.optionsCa.push({
        label: `${ca.code}-${ca.status}`,
        value: ca.id,
      });
    });
  } catch (error) {
    console.log(error);
  }
};

const listarGrupos = async (val) => {
  try {
    const response = await store.dispatch("integracao/listarGrupos", {
      per_page: 100,
      vendor_id: store.state.org.unidadeData.id,
      search: val,
    });
    options.value.optionsGrupo = response.data.results.data;
  } catch (error) {
    console.log(error);
  }
};

const resetCampos = () => {
  dados.value = {
    code: "",
    name: "",
    codigo_integracao: "",
    codigo_integracao_ca: "",
    ca_id: "",
    measurement_unit: "",
    measurement_unit_description: "",
    product_category_id: "",
    product_group_id: "",
    price: "",
    is_epi: { label: "", value: "" },
  };
};

const resetCamposEditar = () => {
  dadosEditar.value = {
    code: "",
    name: "",
    codigo_integracao: "",
    codigo_integracao_ca: "",
    ca: {
      code: "",
      created_at: "",
      deleted_at: "nul",
      expires_in: "",
      id: "",
      reportavel: "",
      status: "",
      updated_at: "",
    },
    measurement_unit: "",
    measurement_unit_description: "",
    product_category: {
      code: "",
      created_at: "",
      description: "",
      id: "",
      updated_at: "",
    },
    product_group: {
      created_at: "",
      description: "",
      id: "",
      name: "",
      updated_at: "3",
      vendor_id: "",
    },
    price: "",
    is_epi: { label: "", value: "" },
  };
};

const listarProdutos = async (page = 1, rowsNumber = 10) => {
  loading.value = true;
  disable.value = true;
  await store.state.org.unidadeData.id;
  try {
    const response = await store.dispatch("integracao/listarProdutos", {
      vendor_id: store.state.org.contract,
      page: page,
      per_page: rowsNumber,
      search: filtrar.value,
    });
    listaProdutos.value = response.data.model.products;
    pagination.value.rowsPerPage = response.data.model.products.per_page;
    pagination.value.page = response.data.model.products.current_page;
    pagination.value.rowsNumber = response.data.model.products.total;
    loading.value = false;
    disable.value = false;
  } catch (error) {
    listaProdutos.value = [];
    pagination.value.rowsPerPage = 0;
    pagination.value.page = 0;
    pagination.value.rowsNumber = 0;
    console.log(error);
  }
};

const receberDadosGrupoCategoria = (dados) => {
  dadosEditar.value.code = dados[0].code;
  dadosEditar.value.name = dados[0]?.pivot?.contract_product_description || dados[0].name;
  dadosEditar.value.ca = dados[0]?.ca;
  dadosEditar.value.product_category = dados[0]?.pivot?.product_category;
  dadosEditar.value.product_group = dados[0]?.pivot?.product_group;
  dadosEditar.value.is_epi = {
    label: dados[0]?.isEpi ? "Sim" : "Não",
    value: dados[0]?.isEpi ? 1 : 0,
  };
  dadosEditar.value.price = parseFloat(dados[0]?.pivot?.price).toFixed(2);
  dadosEditar.value.measurement_unit =
    dados[0]?.stock[0]?.pivot.measurement_unit;
  dadosEditar.value.measurement_unit_description =
    dados[0]?.stock[0]?.pivot.measurement_unit_description;
};

const receberDadosIntegracao = async () => {
  try {
    const response = await store.dispatch("integracao/receberDadosIntegracao", {
      per_page: 1000,
      unidade_codigo: store.state.org.unidadeData.codigoIntegracaoUnidade,
    });
    if (response.data.results.data.length) {
      const array = response.data.results.data.filter((dado) => {
        return dado?.codigo_epi == selected.value[0]?.code;
      });
      dadosEditar.value.codigo_integracao = array[0]?.codigo_integracao_epi;
      dadosEditar.value.codigo_integracao_ca = array[0]?.codigo_integracao_ca;
    }
  } catch (error) {
    console.log(error);
  }
};

watch(
  () => selected.value,
  () => {
    resetCamposEditar();
    if (selected.value.length > 0) {
      receberDadosGrupoCategoria(selected.value);
      receberDadosIntegracao();
    }
  }
);

watch(
  () => pagination.value.page,
  () => {
    listarProdutos(pagination.value.page, pagination.value.rowsPerPage);
  }
);

watch(
  () => filtrar.value,
  () => {
    listarProdutos();
  }
);

watch(
  () => store.state.org.unidadeData.id,
  () => {
    listarProdutos();
    selected.value = [];
  }
);

watch(
  () => rightDrawerOpen.value,
  () => {
    if (rightDrawerOpen.value == true) {
      selected.value = [];
    }
  }
);

onMounted(listarProdutos);

const filtrarCategoria = (val, update) => {
  listarCategorias(val);
  setTimeout(() => {
    update();
  }, 1000);
};

const filtrarCa = (val, update) => {
  listarCas(val);
  setTimeout(() => {
    update();
  }, 1000);
};

const filtrarGrupo = (val, update) => {
  listarGrupos(val);
  setTimeout(() => {
    update();
  }, 1000);
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
.container-edicao {
  border: 1px solid #707070;
  padding: 30px 15px;
  border-radius: 5px;
  margin-top: 30px;
}
.container {
  height: 100%;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
</style>
